import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { AtividadeTipo, atividadesTiposLancamentoManual, isTipoEntrarEmContato, isTipoVisitar, isTipoTarefa } from '..';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

interface Config {
    isEntrarEmContato: boolean;
    isVisitar: boolean;
    isTarefa: boolean;
    isValid?: boolean;
}

@Component({
    selector: 'sgt-atividade-tipo-select',
    templateUrl: './atividade-tipo-select.component.html',
    styleUrls: ['./atividade-tipo-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AtividadeTipoSelectComponent), multi: true },
    ]
})
export class AtividadeTipoSelectComponent implements OnInit {
    config: Config;

    /** Tipos disponíveis para serem selecionados */
    tiposOptions = atividadesTiposLancamentoManual;

     /** Tipo de atividade */
     @Input() ngModel: number;
     /** Ao alterar o tipo de atividade */
     @Output() ngModelChange = new EventEmitter<number>();

    /** Tipo de atividade selecionado */
    tipo: AtividadeTipo;
    /** Tipo de atividade alterado */
    @Output() tipoChange = new EventEmitter<AtividadeTipo>();

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /** Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se o tipo é obrigatório */
    @Input() required = false;

    @ViewChild('dropdownToggle') dropdownToggle: ElementRef;

    propagateChange: any = () => {};

    ngOnInit(): void {
        this.tipo = this.tiposOptions.find(tipoFilter => tipoFilter.id == this.ngModel);
        this.setConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'ngModel' && !changes[propName].isFirstChange()) {
                this.tipo = this.getTipo(this.ngModel);
                this.setIsValid();
            } else if (propName === 'required') {
                this.setIsValid();
            }
        }
    }

    /** Obtem o tipo através do ID */
    private getTipo(id: number): AtividadeTipo {
        if (!id || !this.tiposOptions) {
            return null;
        }
        return this.tiposOptions.find(tipoFilter => tipoFilter.id === id);
    }

    /** Ao selecionar o tipo de atividade */
    onChange(tipo: AtividadeTipo) {
        this.ngModel = tipo ? tipo.id : null;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);

        this.tipo = tipo;
        this.tipoChange.emit(this.tipo)

        this.setConfig();
    }

    /** Seta as configs. do select */
    private setConfig() {
        this.config = {
            isEntrarEmContato: isTipoEntrarEmContato(this.ngModel),
            isVisitar: isTipoVisitar(this.ngModel),
            isTarefa: isTipoTarefa(this.ngModel)
        }
        this.setIsValid();
    }

    private setIsValid() {
        if (!this.config) {
            return;
        }

        // Obrigatório e não selecionada o tipo
        if (this.required && !this.ngModel) {
            this.config.isValid = false;
            return;
        }

        this.config.isValid = true;
    }

    get isValid(): boolean {
        return this.config.isValid;
    }

    /** Seta foco no select */
    setFocus() {
        jQuery(this.dropdownToggle?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
